/** 
* Replace Table Images
*
*/
const replaceTableImages = () => {
	let allCells = document.querySelectorAll('.tablepress tbody tr td');
	let rootImgTick = 'https://brightlocal.com/wp-content/uploads/2018/11/tick.png';
	let rootImgTickAlt = 'https://www.brightlocal.com/wp-content/uploads/2018/11/tick.png';
	let rootImgCross = 'https://brightlocal.com/wp-content/uploads/2018/11/cross.png';
	let rootImgCrossAlt = 'https://www.brightlocal.com/wp-content/uploads/2018/11/cross.png';

	let replaceImgTick = 'https://www.brightlocal.com/wp-content/themes/brightlocal-2021/dist/images/new-tick.svg';
	let replaceImgCross = 'https://www.brightlocal.com/wp-content/themes/brightlocal-2021/dist/images/new-cross.svg';

	allCells.forEach((cell) => {
		if (cell.getElementsByTagName('img').length > 0) {
			let img = cell.getElementsByTagName('img');
			let imgSrc = img[0].src;

			if (imgSrc === rootImgTick || imgSrc === rootImgTickAlt) {
				img[0].src = replaceImgTick;
			}

			if (imgSrc === rootImgCross || imgSrc === rootImgCrossAlt) {
				img[0].src = replaceImgCross;
			}
		}
	});
}

export default replaceTableImages;